import {createApi} from '@reduxjs/toolkit/query/react';
import {createBaseQuery} from '../../utils/apiUtils';
import GlobalConst from "../../constants/GlobalConst";
import Cookies from "js-cookie";

export const tradefanApi = createApi({
    reducerPath: 'tradefanApi',
    baseQuery: createBaseQuery(GlobalConst.TF_API.FULLURL),
    endpoints: (builder) => ({
        getAccount: builder.query({
            query: (token) => ({
                url: 'Accounts/Current',
                method: 'GET',
            }),
        }),
        getMLBPlayerGamesStatsByPlayerId: builder.query({
            query: ({playerId, from, to}) => ({
                url: `/Sports/MLB/Players/${playerId}/GamesStats?from=${from}&to=${to}`,
                method: "GET"
            })
        }),
        getMLBPlayerSeasonStatsByPlayerId: builder.query({
            query: ({playerId, seasonYear}) => ({
                url: `/Sports/MLB/Players/${playerId}/SeasonStats?seasonYear=${seasonYear}`,
                method: "GET"
            })
        }),
        getNFLPlayerGamesStatsByPlayerId: builder.query({
            query: ({playerId, from, to, teamId}) => ({
                url: `Sports/NFL/Players/${playerId}/GamesStats?from=${from}&to=${to}&teamId=${teamId}`,
                method: "GET"
            })
        }),
        getNFLPlayerSeasonStatsByPlayerId: builder.query({
            query: ({playerId, seasonYear}) => ({
                url: `Sports/NFL/Players/${playerId}/SeasonStats?seasonYear=${seasonYear}`,
                method: "GET"
            })
        }),
        getSoccerPlayerGamesStatsByPlayerId: builder.query({
            query: ({playerId, from, to, teamId}) => ({
                url: `Sports/Soccer/Players/${playerId}/GamesStats?from=${from}&to=${to}&teamId=${teamId}`,
                method: "GET"
            })
        }),
        getSoccerPlayerSeasonStatsByPlayerId: builder.query({
            query: ({playerId, seasonYear}) => ({
                url: `Sports/Soccer/Players/${playerId}/SeasonStats?seasonYear=${seasonYear}`,
                method: "GET"
            })
        }),
        getNHLPlayerGamesStatsByPlayerId: builder.query({
            query: ({playerId, from, to, teamId}) => ({
                url: `Sports/NHL/Players/${playerId}/GamesStats?from=${from}&to=${to}&teamId=${teamId}`,
                method: "GET"
            })
        }),
        getNHLPlayerSeasonStatsByPlayerId: builder.query({
            query: ({playerId, seasonYear}) => ({
                url: `Sports/NHL/Players/${playerId}/SeasonStats?seasonYear=${seasonYear}`,
                method: "GET"
            })
        }),
        getNBAPlayerSeasonStatsByPlayerId: builder.query({
            query: ({playerId, seasonYear}) => ({
                url: `Sports/NBA/Players/${playerId}/SeasonStats?seasonYear=${seasonYear}`,
                method: "GET"
            })
        }),
        getNBAPlayerGamesStatsByPlayerId: builder.query({
            query: ({playerId, from, to, teamId}) => ({
                url: `Sports/NBA/Players/${playerId}/GamesStats?from=${from}&to=${to}&teamId=${teamId}`,
                method: "GET"
            })
        }),
        getGolfPlayerGamesStatsByPlayerId: builder.query({
            query: ({playerId, from, to}) => ({
                url: `Sports/Golf/Players/${playerId}/GamesStats?from=${from}&to=${to}`,
                method: "GET"
            })
        }),
        getProducts: builder.query({
            query: () => ({
                url: `Products?siteTLD=${GlobalConst.SITE_TLD}`,
                method: 'GET',
            }),
        }),
        //"POST", `Orders/Nuvei/InitiatePayment`
        initiateNuveiPayment: builder.mutation({
            query: (data) => ({
                url: `Orders/Nuvei/InitiatePayment`,
                method: 'POST',
                body: JSON.stringify(data),
            }),
        }),

        initiateSkrillPayment: builder.mutation({
            query: (data) => ({
                url: `Orders/Skrill/InitiatePayment`,
                method: 'POST',
                body: JSON.stringify(data),
            }),
        }),

        addFunds: builder.mutation({
            query: (data) => ({
                url: `Orders/AddFunds`,
                method: 'POST',
                body: JSON.stringify(data),
            }),
        }),
        getHasReceivedDepositBonus: builder.query({
            query: () => ({
                url: `Accounts/Transactions/HasReceivedBonus`,
                method: 'GET',
                keepUnusedDataFor: 0,
            }),
        }),
        getHasReceivedFirstTimeMxnDepositBonus: builder.query({
            query: () => ({
                url: `Accounts/Transactions/HasReceivedFirstTimeMxnDepositBonus`,
                method: 'GET',
                keepUnusedDataFor: 0,
            }),
        }),
        getHasReceivedFirstTimeUsdDepositBonus: builder.query({
            query: () => ({
                url: `Accounts/Transactions/HasReceivedFirstTimeUsdDepositBonus`,
                method: 'GET',
                keepUnusedDataFor: 0,
            }),
        })
    }),
});

export const uploadPictureAsync = (file)=>{
    const token = Cookies.get('tfsession');
    return new Promise((resolve, reject)=>{
        try {
            fetch(GlobalConst.TF_API.FULLURL+ '/Accounts/UploadPicture',
                {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                    },
                    body: file
                }
            ).then(response=>{

                if (response.ok)
                    resolve(response);

            }).catch(err=>{
                reject(err);
            });

        } catch (error) {
            console.error('API Error:', error);
            reject(error);
        }
    });
}

export const {
    useGetAccount,
    useGetMLBPlayerGamesStatsByPlayerIdQuery,
    useGetMLBPlayerSeasonStatsByPlayerIdQuery,
    useGetNFLPlayerGamesStatsByPlayerIdQuery,
    useGetNFLPlayerSeasonStatsByPlayerIdQuery,
    useGetSoccerPlayerGamesStatsByPlayerIdQuery,
    useGetSoccerPlayerSeasonStatsByPlayerIdQuery,
    useGetNHLPlayerGamesStatsByPlayerIdQuery,
    useGetNHLPlayerSeasonStatsByPlayerIdQuery,
    useGetNBAPlayerSeasonStatsByPlayerIdQuery,
    useGetNBAPlayerGamesStatsByPlayerIdQuery,
    useGetGolfPlayerGamesStatsByPlayerIdQuery,
    useGetProductsQuery,
    useInitiateNuveiPaymentMutation,
    useInitiateSkrillPaymentMutation,
    useAddFundsMutation,
    useGetHasReceivedDepositBonusQuery,
    useGetHasReceivedFirstTimeMxnDepositBonusQuery,
    useGetHasReceivedFirstTimeUsdDepositBonusQuery
} = tradefanApi; // Export hooks

export default tradefanApi;
